import React from "react";
import { CustomTable } from "../../../Shared";

export function ListGrades(props) {
  const {
    grades = [],
    loading = false,
    error = null,
    tableConfig,
    onReload
  } = props;

  if (error) {
    return (
      <p style={{ color: "red", textAlign: "center", margin: "1rem 0" }}>
        {error}
      </p>
    );
  }

  return (
    <div className="student-my-grades__list">
      <CustomTable
        tableConfig={tableConfig}
        data={grades}
        loading={loading}
        onReload={onReload}
      />
    </div>
  );
}
